export const options = {
  grounds: ['CTS', 'DGS', 'GTS', 'TCS', 'VTS', 'NHS', 'TTS', 'HTS'],
  priorities: ['Low', 'Medium', 'High'],
  modes: ['Full Automation', 'Semi-Automation', 'Manual'],
};
